<template>
  <div class="tc-configurator-right-sidebar-summary">
    <div class="tc-summary-head">
<!--      <div v-if="projectCost">Стоимость проекта:</div>-->
<!--      <div v-if="projectCost"> {{ projectCost }} {{ currencySymbol }}</div>-->
<!--      <div v-if="!projectCost">Рассчитывается индивидуально</div>-->
      <div v-if="useStoreProjectStructure().checkIsDefaultColor">Стоимость проекта:</div>
      <div v-if="useStoreProjectStructure().checkIsDefaultColor"> {{ computeProjectCost }} {{ currencySymbol }}</div>
      <div v-if="!useStoreProjectStructure().checkIsDefaultColor">Рассчитывается индивидуально</div>
    </div>
    <div class="tc-summary-count">
      <div>Всего шкафов в проекте:</div>
      <div class="bc-link"
           @click.stop="storeUI.setLeftSidebarTab('project')">
        {{ casesCount }} шт.
      </div>
    </div>
    <div class="tc-summary-buttons-options">
      <OutlineButton :text="'Скачать в PDF'"
                     @click="onDownloadPDF()"/>
      <OutlineButton :text="'Выставить счет'"
                     @click="onInvoice()"
                     v-if="isDealerClient"/>
    </div>
    <OrangeButtonOfLawlessness :text="'Оформить заказ'"
                               @click="onOpenOrderModal()"/>
  </div>
</template>

<script>
import OrangeButtonOfLawlessness from '@/UI/CommonComponents/OrangeButtonOfLawlessness.vue';
import OutlineButton from '@/UI/CommonComponents/OutlineButton.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreItemsFromApi } from '@/Store/storeItemsFromApi';
import { loadResultPDF } from '@/pdf/createPdf';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { invoice } from '@/utils/postmessages';
import { computeConfigurationCost, computeProjectCost } from '@/libs/calcConfigurationCost';
import { roleCheck } from '@/libs/roleCheck';
import { useStoreMeta } from '@/Store/storeMeta';
import { updateImagesOnConfigurationChange } from '@/libs/updateImagesOnConfigurationChange';

export default {
  name: 'RightSidebarSummary',
  components: {
    OutlineButton,
    OrangeButtonOfLawlessness,
  },
  setup() {
    const storeCaseConfiguration = useStoreCaseConfiguration();
    const storeUI = useStoreUI();
    const storeItemsFromApi = useStoreItemsFromApi();
    const storeProjectStructure = useStoreProjectStructure();
    const storeMeta = useStoreMeta();
    return {
      storeUI,
      storeCaseConfiguration,
      storeItemsFromApi,
      storeProjectStructure,
      storeMeta,
    };
  },
  computed: {
    // getIsDefaultColorSettings(){
    //   return  computeProjectCost;
    // },
    projectCost(){
      return  this.storeProjectStructure.getProjectTotalPrice;
    },
    casesCount() {
      let counter = 0;
      this.storeProjectStructure.cases.forEach((item) => {
        counter += +item.count;
      });
      return counter;
    },
    isDealerClient() {
      return roleCheck([ 'dealer', 'employee' ]);
    },
    currencySymbol() {
      return this.storeMeta.currency;
    },
    computeConfigurationCost,
    computeProjectCost,
  },
  methods: {
    useStoreProjectStructure,
      onDownloadPDF() {
          updateImagesOnConfigurationChange();
          loadResultPDF();
      },
      onInvoice() {
          updateImagesOnConfigurationChange();
          invoice();
      },
      onOpenOrderModal() {
          updateImagesOnConfigurationChange();
          this.storeUI.setActiveModalName('order');
          this.storeUI.setIsShowModal(true);
      },
  },
};
</script>

<style scoped lang="scss">
.tc-configurator-right-sidebar-summary {
  height: max-content;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  pointer-events: all;
  padding: 15px;
  gap: 5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-summary-head {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
}

.tc-summary-count {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  color: #33333380;
}

.tc-summary-buttons-options {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0;
}
</style>
